module.exports = __webpack_public_path__ + "static/image/music/pc/robot-fantasia.ver2_0_2.jpg?35b20622";